module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("One")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("AFTER THE")]), _vm._v(" stuffiness of the airport and the long, hot stretches of shimmering highway, the clean, cool ocean breeze was bliss.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben looked up to watch a couple of seagulls swoop and dive through the summer sun-bleached sky and then looked back in the direction the ferry was moving. The island up ahead had once been a speck in the distance. Now it was resolving into long beaches dotted with the bobbing, tufted heads of palm trees. Most of the island seemed to hug the pool-blue water, but on one side of the island a hill rose up. Houses clung to the flanks of the hill, their big windows facing out to sea. Above them all, at the top of the hill, were two identical white houses, each looking out in opposite directions.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Bunker Island had been the getaway of celebrities in the ’40s and ’50s, before Santa Catalina Island became the more attractive proposition. In the island’s heyday, all Ben’s favorite movie stars had owned a house here. One of the pretty little villas that dotted the hill’s flanks had hosted Katherine Hepburn after work on "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Bringing up Baby")]), _c('i'), _vm._v("had wound down. And according to the Internet, both Shirley Temple and Judy Garland had stayed at the Twin Palms resort. Maybe even in the bungalow he’d be staying in.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("BEN’S SHOULDERS")]), _vm._v(" relaxed. He hadn’t realized they’d been tense before, but every mile from mainland California seemed to ease the stress in his neck another notch. Two weeks of sun, sand, and long sleep-ins. Wallowing in the elegance of Hollywood past. As many old movies as he could watch. All of it, for two weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He could take it easy and let his leg and chest heal. Not that they weren’t better already, as far as the doctors were concerned. Nine months was plenty of time for open-heart surgery recovery, they told him, and if Ben was being honest with himself, he felt about as good as he ever had.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But Ben still found himself rubbing at the numb patch on his chest sometimes, where the nerve had been severed by the surgeons, or rubbing at his leg, where a phantom ache reminded him the doctors had taken a vein out to repair the damage to his heart.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("After this")]), _vm._v(", Ben thought, "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I’ll be ready to go back to work. Totally.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He tried to ignore how even the thought of going back to work made the tension in his shoulders ratchet back up. Instead, he went back to the seating area of the open deck and dropped onto a sun-warm bench.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But the thought of going back to work clung to him like a bad smell. If he closed his eyes he could still see, with almost high-def detail, the trench plate coming toward him. A thousand pounds of rusting metal that had suddenly broken free of the safety lines, spun out of control, and struck him in the chest.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He shook his head to get the image out of his mind. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Ten years working as a welder, and all you can think about is the one big accident")]), _vm._v(", he thought. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("C’mon, Benji. You’ve got to get over this.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He blinked the memory away and looked resolutely at the island, growing golden and beautiful, festooned with drooping palms and jeweled with sprawling white houses, haunted by the ghosts of the silver screen. Plus, Bree and Nate, his two best friends in the world, were treating him. Two weeks of free vacation. Sunshine. A breeze warm enough to wick the sweat from his skin. A pile of his favorite old movies to watch.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Even with the beach and movies, after two weeks he’d be bored. He’d be itching to go home and get back to work. He loved his work; he’d never been seriously injured by it before. Sure, the odd sprain, or gash, or metal sliver. But nothing like what happened with the trench plate.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Everyone agreed it had been a freak accident. Nobody could have anticipated a gust of wind that strong. There had only been one guy on the safety line, and the kid hadn’t been wearing gloves, so of course the rope burned right out of his hands. The whole accident had just been a bunch of random things that had come together all at once, but it would never happen again.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Yeah.")]), _vm._v(" Ben pushed aside the twist of anxiety in his belly and made himself stop rubbing at the surgical scar on his chest. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Yeah")]), _vm._v(", he thought."), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v(" In two weeks I’ll be dying to get back to work.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He frowned at the thought. Maybe "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("dying")]), _vm._v(" hadn’t been the best choice of word. He was still thinking about it when the ferry bumped gently against the dock and it was time to go.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("HE HURRIED")]), _vm._v(" down the gangway and looked around the arrivals area.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Ben!” someone called.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He turned to see Bree, tanned and cute and dark, and Nate, sunburned and grinning, coming toward him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hey, you guys,” Ben called back, hurrying to meet them.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Look at you, man. You look great. What is that? A sixty-dollar haircut?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben laughed. “I think that’s called bed head.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate grabbed the bag out of his hand, and Bree threw her arms around Ben’s neck and kissed him on the cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You look great,” Bree said, holding him at arm’s length and nodding her satisfaction. “Way better than I expected.” She blinked then, her eyes suddenly bright. “Oh man, I’m so glad.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben’s smile fixed into place like plaster drying. He’d never been good with attention, and the accident had made him a sort of minor celebrity in his hometown and among his friends.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hey, it’s okay, Bree. It wasn’t as bad as everybody says.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate gave him an incredulous look. “Actually, dude, it totally was.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Open-heart surgery isn’t as big a deal as it used to be.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Surgery is a big deal, Ben,” Bree said, wiping her eyes with the back of her hand. “Add ‘open’ and ‘heart’ to that? Actual genuine big deal.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Didn’t think you’d make it out here for—” Nate looked around like he was looking for a calendar. “—I don’t know. A few more months at least.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben shrugged. “Eight, nine months’ recovery time,” he said, shrugging. “That’s it. The modern world’s a pretty amazing place.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Bree sniffled. He looked back at her. She was still wiping her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Seriously, Bree, you okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Shut up,” she said, pretending to slap at his arm. “I’m emotionally overwhelmed.” She looked up and blinked a few more times. “And it’s all your fault. You should feel bad.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I don’t,” Ben said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate grinned at him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“How’re you feeling? Are you tired out from the trip? Hungry?” he asked. He started up the sloping road toward the gatehouse. Beyond it lay a few shops, a medical clinic and a pharmacy, a couple of cafes with their furniture clustered under big umbrellas, and not much else.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Where did you guys park?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Bree laughed. “At the resort,” she said. “We brought the car, but it’s a tiny island. Most people walk everywhere. Which reminds me.” She dug into her pocket. “In case you want to go for a drive while we’re at the wreck.” She tossed him the keys. “Greta Garbo used to own one of the big houses at the top of the hill,” she added.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Actually,” Ben said, “she used to own them both—they used to be two wings of the same house, till the Durhams bought it and split it in the ’80s.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Outnerded,” Nate murmured at Bree.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Old Hollywood trivia. I never stood a chance.” She grinned at Ben.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("THEY REACHED")]), _vm._v(" the main road, and the smooth pavement of the dock gave way to streets paved with brick. At the far end of what looked like a little town square, he saw a single car, a yellow Lamborghini, squatting like a poisonous frog in front of a tidy little grocery store, the sort with fruit and vegetables in baskets.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Speaking of the Durhams,” Bree said, nodding at the car.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Got to be Jamie Durham,” Ben said, thinking back to the gossip magazines he’d seen in the ferry terminal gift shop.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Actually, the uncle. What’s his name? Something super old-world Irish.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Ewan,” Nate said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Bree shot him a look. “Scottish.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Angus.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Also Scottish.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben tried to remember. Jamie was the wayward son, Juniper was the straightlaced daughter, the dad, Steven, had recently died and… “Finnegan,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Damn,” Bree murmured. “Outnerded twice in one conversation.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben shrugged. “I’ve spent an unholy amount of time in waiting rooms the last six months. Ask me about the newest superfood. C’mon, ask.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Bree snorted and gave him a little push. “Hey,” she said, “you hungry?” She pointed to a little pizza shop.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Naw, I’m good.” He smiled at her. “I packed a lunch and ate it on the ferry. Got to keep costs down.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“God,” Nate murmured. He’d been looking longingly at the pizza place but turned back to Ben. “I don’t even want to know what your bills are like.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Well,” Ben said, the tension coming back like the tide. “If you guys hadn’t said the bungalow was free, I’d’a never come. Tell me there’s a kitchen in it. Please.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“There’s a kitchen,” Bree said. “Well. A microwave and a hot plate and a bar fridge anyway.” She shaded her eyes. “There,” she said, pointing.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben followed her finger and looked. The island crested and dipped down again. It couldn’t be more than a hundred feet above sea level here, and Ben could see how, beyond the little one-street town that hunkered at the bottleneck of the island, a long golden beach went spilling down toward a glittering blue sea.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“That’s the resort. Long walk, huh?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And here I thought I was going to get some exercise,” Ben said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You want to exercise, you can wash my scuba gear,” Nate told him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Bree made a face and shook her head. “Don’t do it, dude,” she told Ben. “He totally pees in that thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate’s sunburned face went even redder. “"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Bree")]), _vm._v("!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You did.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Once! Because I couldn’t get the stupid valve undone.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Excuses,” she said. She leaned over to Ben and stage-whispered, “I call it the pee suit now.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben gave up trying not to laugh. The movement of his shoulders tugged the scar tissue in his chest and made him think, "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Is this okay for my heart?")]), _vm._v(" Which, he realized, meant he hadn’t laughed, not really, in a hell of a long time.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Thanks, guys,” he said, a little more serious than he wanted to be. “This is going to be great. This is exactly what I need. It was really good of you to organize.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Just glad to have you around, man,” Nate answered, matching Ben’s tone. He pointed at the expanse of beach, and Ben could see now it was lined on one side by little buildings, the seaside bungalows Nate had told him about. “We’re crashing in number six when we’re not at the wreck, and we put you in lucky number seven, since you’re basically the luckiest man alive.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Uh, me?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Uh, yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Except for all those people who haven’t, you know, almost been killed on the job.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Well, okay, yeah,” Nate admitted. “Except for them.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("At the resort gate, Bree waved good-bye and went to the washhouse to go get her laundry. “Nate! We’ve got that reservation,” she hollered over her shoulder. “Don’t forget to tell him!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Reservation?” Ben asked, following Nate into the reception area.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“The restaurant here is really good. Don’t worry, we’ll cover it.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben shook his head. “No, you guys….”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Seriously, it’s a few bucks, and it’s not like we’re not getting paid out here. Plus, it’s not like we have a lot of expenses. But we, uh….” Nate gave him a sheepish look. “We thought you’d be coming with Liam.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah.” Ben tried not to notice a little pinch of sadness and anger in his belly. “So did I.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah, well, the guy’s a douche canoe. Too bad none of us knew before.” Nate led him through a pair of wide double doors that opened into a flagstone-floored reception area with a check-in desk on one side and the doorways leading to the restaurant and the spa on the other. A third doorway, another set of double doors, stood open and looked out on a golden beach and impossibly blue water.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hey, Zu. This is my buddy Benji Rao. He’s booked in at number seven.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Just need a piece of ID and we’ll get you checked in,” the woman said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh yeah, of course,” Ben answered and fished his wallet out.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You’re just lucky you guys weren’t married,” Nate said. “You might have had to share that settlement with him. Imagine that.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben nodded. “Okay, yes. It could have been worse.” Still, getting out of an overnight in the hospital to find Liam and all his stuff, and a substantial portion of Ben’s stuff, missing from the apartment "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("and")]), _vm._v(" the rent unpaid…. “But it was still pretty shitty.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Zu pretended not to hear. She finished typing in the numbers and glanced at the computer, then retrieved a key from the wall behind her. “It’s all ready for you, Mr. Rao. You can go ahead and get comfortable. Anything you need, just come to the desk and ask.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Thanks,” he said and took the key.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate grabbed his bag from where he’d dropped it on the floor. “Anyway, screw that guy,” he said. “And honestly, considering what he did? I’m glad he’s gone. You deserve better.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben smiled faintly. “Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s just the truth. Anyway, Bree made the rezzos for four. And you know how she is.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben groaned. Then something occurred to him. “Wait, rezzo"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("s")]), _vm._v("? As in, more than one?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Uh, yeah. There’s dinner tonight and a thing on Friday.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“A thing? A…. Nate, I brought flip-flops, T-shirts, and something to swim in.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s okay. It’s all on-resort and there’s no dress code. It’s fine. They even do North Indian stuff, if you’re looking for home cooking.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Nah. Nobody makes roti like Mom,” Ben said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Knew you’d say no. Bree said to tell you anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Look,” Ben said quietly, “I don’t want to be a pain in the ass, but the fact is, I can’t afford to be eating out right now. I was going to go get some groceries after this. Like, instant noodles.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Naw, man, we’ve got you covered.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Nate, you guys don’t have to buy me all this stuff.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Look, we….” Nate ran a hand through his sun-bleached hair and sighed. “Okay, so….” He hesitated.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Nate, man. I’ve got a bad heart.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sorry, it’s just kind of weird.” He grinned so hard Ben thought he might split his chapped lips. “We were salvaging last year and got that cargo, remember? The one with the wine in it?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben nodded. He vaguely remembered something about that. “I had a lot of morphine last year,” he said. “Remind me.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate snorted.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“We got these two crates of wine, off a French ship. I guess it was kind of a big deal, like from before an American fungus took out all the French grapes? I don’t know. I don’t drink wine. Anyway, it went to auction in May and….” He hesitated. “Wine snobs went nuts. We’re… good for money right now. Maybe for a while. We bought a new boat, and this new salvage is looking pretty promising too.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Relief flooded him. “Holy shit. I thought you were going to say you guys were running drugs from Mexico or something.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What?” Nate actually looked shocked. “Ben, I’m not an idiot.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You suddenly have an awful lot of money, and then you had a surprise….”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Actually, that’s not the only surprise. There’s something else. Bree’ll probably kill me, but….” He smiled sheepishly. “She’s pregnant. Due in January. We’re going to get married in August.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Wait, "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("what")]), _vm._v("?” Ben shouted. “But, no, wait, can she dive when…?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“She’s doing all the surface stuff and remote operations stuff. It means I’m probably diving a bit too much, but we’re on schedule with that salvage, and so far everything’s within regular parameters, so….” He shrugged, grinning broadly now.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Holy shit,” Ben said again, softly this time. “Congratulations.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate blinked a couple of times and then cleared his throat. He elbowed Ben, not too hard, in the ribs. “Don’t get all choked up on me, buddy.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You know me. I cry at everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate’s grin got even bigger. “Our folks don’t even know yet, so maybe keep it on the down low?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Who’m I going to tell? Liam? My mom and dad?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate snorted. “Your mom would love it.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Okay, yeah, true. But then the uncomfortable conversation.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate frowned at him. “You’re out to your folks, aren’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yes, and if you recall, the day my mom found my Facebook was almost as bad as the day I told her I was going to be a welder.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate laughed. So did Ben, but it was only to hide the cringe. Ben shook his head. “My parents expect me to adopt someday. But I am not ready for kids.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Well, you can borrow mine,” Nate said, punching him lightly on the arm. “C’mon, let me show you your place.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He pushed his way through the doors and out to the beach, and Ben followed. Sunshine gilded the faded wooden boardwalk that wound like a serpent basking among the dunes. The water, blue-green and shimmering, sighed and rolled against a shore dotted with bright umbrellas and beach towels, and a little farther out, he could see the pinprick shapes of surfers paddling after the big waves beyond the breakwater. At one side of the beach there was the pool house and the spa, and on the far side were a dozen or so neat little bungalows arranged in two staggered rows, all painted white with a number on the side in either teal green or ocean blue, and all of them facing the placid beach.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Wow,” Ben said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I know,” Nate agreed, smiling like the place was his. “Pretty all right, isn’t it?” He glanced at Ben again. “I know you don’t have a dive ticket, but there’re surfing lessons, and there’s snorkeling, and since you’re single….” He let his voice trail off and grinned.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh no,” Ben said. “Don’t you start.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Benji, I am your oldest friend.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No, Nate.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Bree’s with me on this.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No, Nate. Wait. You guys talk about my sex life?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate shrugged. “The lack of it, yeah, sometimes.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Nate")]), _vm._v("!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“So look, all the reservations we made, we made them for four. You know how Bree is about empty chairs at dinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Yeah, he did. She had a "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("thing")]), _vm._v(" about them and would do whatever it took to fill them, including but not limited to going out to a restaurant parking lot and inviting a random passerby to dinner once.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“All I’m saying is, you’re on vacation for the first time in your life. Do you know how to not work?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Seriously, I’ve never seen anybody work as hard as you do. But now you’re on vacation, so you should, you know, "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("vacay")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I don’t think that’s actually a word.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sure it is,” Nate said breezily. “Pick somebody up at the bar. Invite some guy you meet at a surfing class to come to dinner. Hell, invite the instructor if you want. Have some fun. No judging from me and Bree, okay? I mean, unless you fail to have fun. Then we will "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("totally")]), _vm._v(" judge you.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("do")]), _vm._v(" have fun,” Ben said, a little defensively.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate gave him a tired look and hopped down from the boardwalk, starting toward the bungalows that lay across sixty feet of hot yellow-white sand. Ben followed, protesting.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I have "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("tons")]), _vm._v(" of fun.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate rolled his eyes. “Tell me again how many hours a week you were working before the accident.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben shut up.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sixty-three,” Nate said. “The week before the accident you worked sixty-three hours. And the week before that? Sixty. The guys I talked to told me you were working way too hard.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I liked my work,” Ben said. He realized after the words had come out of his mouth exactly what he’d said, but Nate didn’t seem to notice.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Dude, I’m an entrepreneur, and I only work an average of fifty hours a week. You got to learn how to relax.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“How?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I watch movies.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate sighed. “Okay, you do "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("one")]), _vm._v(" thing that isn’t work.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I… hey.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“So we’re just going to help facilitate you learning to relax.” Nate shot him a serious glance. “The last time I saw you, you were laid up in the hospital doped up on drugs and you had almost been killed at work, and when I asked if you were okay, you told me you felt like you’d wasted your life.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("As if Ben could have forgotten saying that. As if he would have forgotten the moment of impact when the trench plate swung free of the guide rope and twisted around, catching him in the chest and throwing him back, then crushing his ribs and pinning him to the dry dock wall. As if he could have forgotten thinking, "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Oh my God, I’m dying, and I never did anything with my life.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate shook his head. “I don’t want you to feel like that anymore.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Nate…,” he started, but didn’t know what to say.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate shrugged. “Something takes me away, I lived the life I wanted to live. I’m happy. But man, I don’t know about you. And you’re a good person, Ben. You deserve to be happy.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben swallowed noisily. “Okay,” he murmured. “But "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("grudgingly")]), _vm._v(". And no blind dates.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Scout’s honor,” Nate said and held up two fingers. Then he pointed across the beach to a white-painted hut with a large green number seven painted on the back. “That’s yours.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben frowned at Nate. “You’ve never been a Scout.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate slapped him on the shoulder. “Better get settled in.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben’s heart went to the bottom, just like a ship.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 60
// module chunks = 0